import { action } from 'satcheljs';
import { MailListRowDragData } from 'owa-mail-types/lib/types/MailListRowDragData';
import { OwaDate } from 'owa-datetime';
import { FullComposeEntrySourceType } from 'owa-calendar-helpers-types';
import { addDatapointConfig } from 'owa-analytics-actions';
import {
    getTimePanelDndCustomData,
    timePanelDndOptions,
    DropEscalateMeetingCustomData,
    DragEscalateMeetingTarget,
} from '../datapoints';

export const dropMailItem = action(
    'dropMailItem',
    (
        dragData: MailListRowDragData,
        entryType: FullComposeEntrySourceType,
        dropTarget: DragEscalateMeetingTarget,
        preFillStartTime?: OwaDate
    ) =>
        addDatapointConfig(
            {
                name: 'timePanelActionCreateMeetingFromEmailDrop',
                options: timePanelDndOptions,
                customData: getTimePanelDndCustomData<DropEscalateMeetingCustomData>({
                    dropTarget: dropTarget,
                }),
            },
            {
                dragData,
                entryType,
                preFillStartTime,
            }
        )
);
